module.exports = __webpack_public_path__ + "images/backgrounds/360-pricing-calculator-bg-b420254671a777187a7b27e36727ea95.webp";